import { Component, Inject, NgZone, OnInit, Optional } from '@angular/core';
import {
  MatDialogRef,
  MatTableDataSource,
  MAT_DIALOG_DATA
} from '@angular/material';
import { DTOCustomerInfo } from '../../../../../@core/models/DTOCustomerInfo';
import { ShipmentService } from '../../../../../@core/services/shipment.service';

@Component({
  selector: 'crm-client-lookup-dialog',
  templateUrl: './crm-client-lookup-dialog.component.html',
  styleUrls: ['./crm-client-lookup-dialog.component.scss']
})
export class CrmClientLookupDialogComponent implements OnInit {
  displayedColumns: string[] = [
    'CustomerId',
    'Name',
    'Address1',
    'City',
    'Phone'
  ];
  query: string;
  key: string;
  userId: string;
  clientLookupDatasource = new MatTableDataSource<DTOCustomerInfo>(null);
  constructor(
    public dialogRef: MatDialogRef<CrmClientLookupDialogComponent>,
    private ngZone: NgZone,
    public shipmentService: ShipmentService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.key = data.key;
    this.userId = data.userId;
  }

  ngOnInit() {}

  public close(): void {
    this.dialogRef.close(null);
  }

  search() {
    this.shipmentService
      .SearchCustomer(this.query, this.userId, this.key)
      .subscribe((res) => {
        this.clientLookupDatasource = new MatTableDataSource<DTOCustomerInfo>(
          res
        );
      });
  }

  selectClient(client: DTOCustomerInfo) {
    this.dialogRef.close(client);
  }
}
